module.exports = __webpack_public_path__ + "static/media/uUmbrella.11877f6d.png";